// components/LoadingOverlay.jsx
import React from "react";

const LoadingOverlay = ({ message = "Uploading..." }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center">
      <div className="flex items-center bg-black bg-opacity-60 px-6 py-4 rounded-lg shadow-lg">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-white"></div>
        <span className="text-white ml-3">{message}</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
